import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const gradientOffset = (data: { year: string; netSaving: number }[]) => {
  const dataMax = Math.max(...data.map((i) => i.netSaving));
  const dataMin = Math.min(...data.map((i) => i.netSaving));

  if (dataMax <= 0) {
    return 0;
  }
  if (dataMin >= 0) {
    return 1;
  }

  return dataMax / (dataMax - dataMin);
};

const formatYAxis = (tick: number) => {
  return `$${tick / 1000}K`;
};

export interface NetSavingsChartProps {
  data: { year: string; netSaving: number }[];
  label: string;
  xAxisLabel: string;
}

const NetSavingsChart: React.FC<NetSavingsChartProps> = ({
  data,
  label,
  xAxisLabel,
}) => {
  return (
    <div style={{ width: "100%", height: "400px" }}>
      <h3
        style={{
          fontWeight: "bold",
          marginLeft: 20,
        }}
      >
        {label}
      </h3>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          width={500}
          height={400}
          data={data}
          margin={{
            bottom: 70,
            left: 10,
            right: 10,
          }}
        >
          <XAxis
            dataKey="year"
            label={{
              value: xAxisLabel,
              position: "bottom",
              fontSize: 20,
              fontWeight: "bold",
              fill: "#000",
            }}
            tickFormatter={(value) => {
              const evenValues = [2, 4, 6, 8, 10];
              return evenValues.includes(Number(value)) ? value : "";
            }}
          />
          <YAxis tickFormatter={formatYAxis} />
          <Tooltip />
          <defs>
            <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset={gradientOffset(data)}
                stopColor="green"
                stopOpacity={1}
              />
              <stop
                offset={gradientOffset(data)}
                stopColor="red"
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="netSaving"
            stroke="#000"
            fill="url(#splitColor)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default NetSavingsChart;
